import _get from 'lodash/get'
import { get as getCookie } from 'cookies-js'
import { getSessionStorage } from '../local-preferences/index'
import { SET_APP_BOOTSTRAP_PHASE } from '../app/actions'
import { SET_RESOLVER_DATA } from '../resolver/actions'
import { selectUserExternalId } from '../user/selectors'
import { URL_GAIA_PROD } from '../url/constants'
import { get as getConfig } from '../../config/index'
import {
  CREATE_SERVER_EVENT,
} from './actions'
import { SET_CHECKOUT_INITIATED } from '../checkout/actions'
import {
  FACEBOOK_PIXEL_TEST_CODE_KEY,
  FACEBOOK_EVENT_NAME_PAGE_VIEW,
  FACEBOOK_EVENT_NAME_LEAD,
  FACEBOOK_EVENT_NAME_INITIATE_CHECKOUT,
  FACEBOOK_EVENT_ACTION_SOURCE,
  SERVER_EVENT_PAGE_VIEW,
  SERVER_EVENT_INITIATE_CHECKOUT,
  SERVER_EVENT_LEAD,
} from '.'
import { sendServerEventLog } from './send-event-log'
import { resolveImpactIrclickidForTracking } from '../impact/index'
import * as ACTIONS from './actions'

const config = getConfig()
const serverEventsActive = !!_get(config, ['features', 'events', 'server'])

export function watchCreateServerEvent ({ after }) {
  return after([
    ACTIONS.CREATE_SERVER_EVENT,
  ], async ({ action, state }) => {
    const { auth } = state
    const { payload } = action
    const facebookPixelTestCode = getSessionStorage(FACEBOOK_PIXEL_TEST_CODE_KEY)
    sendServerEventLog({ auth, payload, facebookPixelTestCode })
  })
}

export function watchServerEventPageView ({ after }) {
  return after([
    SET_APP_BOOTSTRAP_PHASE,
    SET_RESOLVER_DATA,
  ], async ({
    action,
    state,
    prevState,
    dispatch,
  }) => {
    const { resolver, app } = state
    const { app: prevApp } = prevState
    const { type } = action
    const fbp = getCookie('_fbp')
    const fbc = getCookie('_fbc')
    const externalId = selectUserExternalId(state)
    const facebookData = {
      event: SERVER_EVENT_PAGE_VIEW,
      data: {
        eventName: FACEBOOK_EVENT_NAME_PAGE_VIEW,
        actionSource: FACEBOOK_EVENT_ACTION_SOURCE,
        eventSourceUrl: `${URL_GAIA_PROD}${resolver.get('path')}`,
        ...(fbp) && { fbp },
        ...(fbc) && { fbc },
        data: {
          externalId,
        },
      },
    }

    if (type === SET_APP_BOOTSTRAP_PHASE) {
      const nextBootstrapComplete = app.get('bootstrapComplete')
      const prevBootstrapComplete = prevApp.get('bootstrapComplete')
      // only fire once on initial page load
      if (nextBootstrapComplete && nextBootstrapComplete !== prevBootstrapComplete) {
        dispatch({
          type: CREATE_SERVER_EVENT,
          payload: facebookData,
        })
      }
    }

    if (type === SET_RESOLVER_DATA) {
      dispatch({
        type: CREATE_SERVER_EVENT,
        payload: facebookData,
      })
    }
  })
    .when(() => {
      return serverEventsActive
    })
}

export function watchServerEventCheckoutInitiated ({ after }) {
  return after([
    SET_CHECKOUT_INITIATED,
  ], async ({
    state,
    dispatch,
  }) => {
    const { resolver } = state
    const fbp = getCookie('_fbp')
    const fbc = getCookie('_fbc')
    const externalId = selectUserExternalId(state)
    const path = resolver.get('path')
    const facebookData = {
      event: SERVER_EVENT_INITIATE_CHECKOUT,
      data: {
        eventName: FACEBOOK_EVENT_NAME_INITIATE_CHECKOUT,
        actionSource: FACEBOOK_EVENT_ACTION_SOURCE,
        eventSourceUrl: `${URL_GAIA_PROD}${path}`,
        ...(fbp) && { fbp },
        ...(fbc) && { fbc },
        data: {
          externalId,
        },
      },
    }

    dispatch({
      type: CREATE_SERVER_EVENT,
      payload: facebookData,
    })
  })
    .when(() => {
      return serverEventsActive
    })
}

export function watchServerEventLead ({ after }) {
  return after([
    ACTIONS.SET_EVENT_LEAD,
  ], async ({
    state,
    action,
    dispatch,
  }) => {
    const { resolver, inboundTracking } = state
    const { payload: email } = action
    const fbp = getCookie('_fbp')
    const fbc = getCookie('_fbc')
    const externalId = selectUserExternalId(state)
    const irclickid = resolveImpactIrclickidForTracking(inboundTracking)
    const path = resolver.get('path')
    const facebookData = {
      event: SERVER_EVENT_LEAD,
      data: {
        eventName: FACEBOOK_EVENT_NAME_LEAD,
        actionSource: FACEBOOK_EVENT_ACTION_SOURCE,
        eventSourceUrl: `${URL_GAIA_PROD}${path}`,
        ...(fbp) && { fbp },
        ...(fbc) && { fbc },
        data: {
          email,
          externalId,
          ...(irclickid) && { irclickid },
        },
      },
    }

    dispatch({
      type: CREATE_SERVER_EVENT,
      payload: facebookData,
    })
  })
    .when(() => {
      return serverEventsActive
    })
}
